import { useState } from "react";

// simplified version of https://usehooks-typescript.com/use-local-storage/
export default function useLocalStorage<T>(key: string, initialValue: T) {
  const [storedValue, setStoredValue] = useState(() => {
    const item = window.localStorage.getItem(key);
    return item ? JSON.parse(item) : initialValue;
  });

  const setValue = (value: T) => {
    setStoredValue(value);
    window.localStorage.setItem(key, JSON.stringify(value));
  };

  // const removeValue = () => {
  //   setStoredValue(null);
  //   window.localStorage.removeItem(key);
  // }
  return [storedValue, setValue];
}
